import './overview.css';
import { parsePurify } from '../../../utils/parsePurify';

export default function Overview({ data }) {
    return <span className='overview'>{parsePurify(data)}</span>;
}
